import { PinterestPinItCounterPosition, PinterestPinItSize } from './types'

type Sizes = Record<'width' | 'height', number>

type ButtonSizes = Record<PinterestPinItCounterPosition, Record<PinterestPinItSize, Sizes>>

export const BUTTON_SIZES: ButtonSizes = {
	none: { small: { width: 50, height: 20 }, large: { width: 67, height: 28 } },
	above: { small: { width: 50, height: 56 }, large: { width: 67, height: 78 } },
	beside: { small: { width: 50, height: 20 }, large: { width: 67, height: 28 } },
}
